import React, { useState } from 'react';

import { SR_API_ACTION_UTILITY_VERIFY_PHONE_SMS_CODE_REQUESTED } from 'api/utilityActionTypes';

import { UTILITY_USER_STATUS_PENDING_SIGNUP } from 'common/utility/userRoles';

import useDispatch from 'client/hooks/useDispatch';
import requestUtilityApi from 'client/actions/requestUtilityApi';
import UtilityAuthActions from 'client/actions/UtilityAuth';

import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import SrUtilitySetupLazyLoginModal from 'client/components/SrUtilitySetup/SrUtilitySetupLazyLoginModal';
import SrUtilitySetupLazySignupModal from 'client/components/SrUtilitySetup/SrUtilitySetupLazySignupModal';
import SrUtilitySetupLazySignupVerificationModal from 'client/components/SrUtilitySetup/SrUtilitySetupLazySignupVerificationModal';

const MODAL_SIGNUP = 'signup';
const MODAL_LOGIN = 'login';
const MODAL_VERIFICATION = 'verificationCode';
const MODAL_SUCCESS = 'success';

const SrUtilitySetupLazySignup = ({ utilityActivation, callbackFunction, onClose }) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(
    utilityActivation.user && utilityActivation.user.status !== UTILITY_USER_STATUS_PENDING_SIGNUP
      ? MODAL_LOGIN
      : MODAL_SIGNUP,
  );
  const [signupApiError, setSignupApiError] = useState(null);
  const [signupData, setSignupData] = useState({});
  const [codeSent, setCodeSent] = useState(false);

  const onSendVerificationCode = (formValues) => {
    dispatch(requestUtilityApi, {
      action: SR_API_ACTION_UTILITY_VERIFY_PHONE_SMS_CODE_REQUESTED,
      payload: {
        phone: formValues.phone,
        isUtilityProfit: false,
      },
      onSuccess: () => {
        setSignupData(formValues);
        setModal(MODAL_VERIFICATION);
      },
    });
  };

  const onSubmitSuccess = () => {
    callbackFunction();
    setModal(MODAL_SUCCESS);
    setTimeout(() => {
      onClose();
    }, 2500);
  };

  const onSubmitError = (error) => {
    setSignupApiError(error);
  };

  const onSignup = (formValues) => {
    setSignupApiError(null);

    if (signupData.loginExist) {
      dispatch(UtilityAuthActions.loginSmsCode, {
        phone: signupData.phone,
        code: formValues.code,
        utilityActivationId: utilityActivation.id,
        leaseStartDate: signupData.leaseStartDate,
        onSuccess: onSubmitSuccess,
        onError: onSubmitError,
      });

      return;
    }

    dispatch(UtilityAuthActions.userSmsCodeSignup, {
      address: utilityActivation.address,
      utilityPartnerId: utilityActivation.partner.id,
      leaseStartDate: signupData.leaseStartDate,
      firstName: signupData.firstName,
      lastName: signupData.lastName,
      email: signupData.email,
      phone: signupData.phone,
      code: formValues.code,
      onSuccess: onSubmitSuccess,
      onError: onSubmitError,
    });
  };

  if (modal === MODAL_SIGNUP) {
    return (
      <SrUtilitySetupLazySignupModal
        defaultValues={signupData}
        onSubmit={onSendVerificationCode}
        onClose={onClose}
      />
    );
  }

  if (modal === MODAL_LOGIN) {
    return (
      <SrUtilitySetupLazyLoginModal
        utilityActivation={utilityActivation}
        callbackFunction={callbackFunction}
        onClose={onClose}
      />
    );
  }

  if (modal === MODAL_VERIFICATION) {
    return (
      <SrUtilitySetupLazySignupVerificationModal
        apiError={signupApiError}
        onSubmit={onSignup}
        codeSent={codeSent}
        onClickResendCode={() => {
          onSendVerificationCode(signupData);
          setCodeSent(true);
          setTimeout(() => {
            setCodeSent(false);
          }, 3000);
        }}
        onClose={() => {
          setModal(MODAL_SIGNUP);
          setSignupApiError(null);
        }}
      />
    );
  }

  if (modal === MODAL_SUCCESS) {
    return (
      <SrSimpleMessageModal
        iconUrl="/images/checkmark-circle-large-green.svg"
        headline="Success"
        maxWidth={400}
        minWidth={400}
        theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      />
    );
  }

  return null;
};

export default SrUtilitySetupLazySignup;
